import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';

const ContactForm = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      setIsLoading(false); // Stop spinner after fetching data
    }, 1000);
  }, []);

  const applyBtnStyle = {
    backgroundColor: '#007bff',
    color: '#fff',
    padding: '2px 4px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: "18px"
  };


  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div >
       {isLoading ? (
  <LoadingSpinner />
) : (
     <div style={{ marginTop: "10px", marginRight:"10px",  display: "flex", justifyContent: "flex-end" }} >
      
      <a href={'https://www.spcommunity.org.za/community-work/'} target="_self" rel="noopener noreferrer">

<button
style={applyBtnStyle}
>
Read about the programme
</button>
</a>

     </div>

     
       )}
      <div>
      <div style={{ marginTop: "10px", marginLeft:"10px",  display: "flex",  fontStyle: "italic", color: "red", fontSize: "22px" }}>Registration for community work is placed on hold, we'll announce its return as soon as possible.</div>

      </div>
     
    </div>
  );


/*
  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <div>
      {isLoading ? (
  <LoadingSpinner />
) : (
      <iframe
        src="https://www.spcommunity.org.za/newsletter"
        style={{ width: "100%", height: "1200px", border: "none" }}
        title="Contact Form"
        onLoad={() => setIsLoading(false)} // Hide spinner when iframe loads
      ></iframe>
    )}
    </div>
  ); */
};

export default ContactForm;
